import React, {
  useMemo,
  useCallback,
  useEffect,
  useState,
  useRef,
} from "react";
import {
    shallowEqual,
    useDispatch,
    useSelector } from "react-redux";
import {
  BillFromMachine,
  BillStatus,
  DELETEBILLCONFIG,
  EPAYMENTSMS,
  GENERATEBILL,
  getDeviceTypeNew,
  INITIATED,
  InternalBillType,
  isRoleAllowed,
  KOTPRINTNOWISE,
  PARTILBILLAUDIT,
  printDebugLog,
  SEND_TO_KITCHEN,
  WHATSAPPBILLCONFIG,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  ROLE_CREATE,
  BILLMGMT,
  ONLINEBILLMGMT
} from "../../../constants/constant";
import { isEmpty } from "lodash";
import EnterButton from "../../global/EnterButton";
import { getConfigValueByKey } from "../../../utilities/commonUtilities";
import BillManagementOtpDialog from "./BillManagementOtpDialog";
import PartialPayDialog from "./PartialPayDialog";
import CustomerCopyBill from "./CustomerCopyBill";
import { useNavigate } from "react-router-dom";
import PrintKotDialog from "./PrintKotDialog";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { INITIAL_PARTIAL_PAY } from "./RestBillConstants";
import { useDeviceType } from "../../global/hooks/useDeviceType";
import { useRestoBillActions } from "../../global/hooks/useRestoBillActions";
import { calculateBillTotal } from "../../../utilities/billCalculatorUtils";
import { updateBillPaymentDetails } from "../../../store/billDetailsSlice";
import { tr } from "date-fns/locale";
import InitiatePaymentWhatsAppDialog from "./InitatePaymentWhtatsAppDialog";
import DialogBox from "../../global/DialogBox";
import DismissButton from "../../global/DismissButton";
import { Box, TextField } from "../../ui";
import "./BillActionButtons.css";

const BillActionButtons = () => {
  const {
    billItems,
    billDetails,
    billHotelDetails,
    billPaymentDetails,
    billCachedProductDetails,
    billCustomerDetails,
    billPartialPaymentDetails,
  } = useSelector((state) => state.bill);

  const restoBillConfig = useSelector((state) => state.restoBillConfig);
  const billPaymentDetailsRef = useRef(billPaymentDetails);

  const dispatch = useDispatch();
  const [showBillOtpDialog, setShowBillOtpDialog] = useState(false);
  //const [billOtp, setBillOtp] = useState("");
  const [showPartialPayDialog, setShowPartialPayDialog] = useState(false);
  const [showCustCopyDialog, setShowCustCopyDialog] = useState(false);
  const [printKotNoDialog, setPrintKotNoDialog] = useState(false);
  const [printDetails, setPrintDetails] = useState({});
  const [disabledButton, setDisableButton] = useState(false);
  const navigate = useNavigate();
  const [partialPay, setPartialPay] = useState(INITIAL_PARTIAL_PAY);
  const [isBillPaid, setIsBillPaid] = useState(false);
  const [initiatePaymentWhatsappDialog, setInitiatePaymentWhatsappDialog] = useState(false);
  const [cancelDialog, setCancelDialog] = useState(false);
  const [cancelReason, setCancelReason] = useState("");

  useEffect(() => {
    console.log("billDetails LeftBillScreenButtons: ", billDetails);
    console.log("billItem LeftBillScreenButtons: ", billItems);
    console.log("restoBillConfig: ", restoBillConfig);
  }, [restoBillConfig]);

  useEffect(() => {
    console.log("showCustCopyDialog changed: ", showCustCopyDialog);
  }, [showCustCopyDialog]);
  // Memoize computed values to avoid recalculating on every render
  // const { isPaid } = billDetails;
  useEffect(() => {
    setIsBillPaid(billDetails.isPaid);
  }, [billDetails.isPaid]);

  useEffect(() => {
    console.log("billItems changed: ", billItems);
    console.log("re-rendering after update");
  }, [
    billItems,
    billDetails,
    billCustomerDetails,
    billHotelDetails,
    billPaymentDetails,
    billPartialPaymentDetails,
  ]);

  ////This is temporary safeguarding check to make sure bill total is always correct.
  const handleBillTotalMismatch = (paymentDetails, billItems) => {
    //console.log("paymentDetails: ", paymentDetails);
    const billSubTotal = billItems.reduce(
      (total, item) => total + (parseFloat(item.finalPrice) || 0.0),
      0.0,
    );

    if (
      parseFloat(billSubTotal).toFixed(2) !==
      parseFloat(paymentDetails.totalPrice).toFixed(2)
    ) {
      //if (billSubTotal !== paymentDetails.totalPrice) {
      printDebugLog("Bill total mismatch detected");
      const billTotalSummary = calculateBillTotal({
        prevTotalPrice: 0.0,
        newTotalPrice: 0.0,
        billTotalPrice: billSubTotal,
        cgstRate: paymentDetails.cgst,
        sgstRate: paymentDetails.sgst,
        pointRedeem: paymentDetails.pointRedeem,
        isGstAllowed: paymentDetails.isGstAllowed,
        deliveryCharge: paymentDetails.deliveryCharge,
        offerType: paymentDetails.offerType,
        offerValue: paymentDetails.offerValue,
        isPartialBillEnabled: paymentDetails.isPartialBillEnabled,
      });
      printDebugLog(
        "handleBillTotalMismatch::billTotalSummary: ",
        billTotalSummary,
      );

      dispatch(
        updateBillPaymentDetails({
          totalPrice: billTotalSummary.totalPrice.toFixed(2),
          cgstAmt: billTotalSummary.cgstAmount.toFixed(2),
          sgstAmt: billTotalSummary.sgstAmount.toFixed(2),
          finalPrice: billTotalSummary.finalPrice.toFixed(2),
          roundOff: billTotalSummary.roundOff.toFixed(2),
        }),
      );
    }
  };

  const getPartialPayButtonName = (billStatus, duesAmt) => {
    let name = "";
    if (billStatus === BillStatus.PARTIALLYPAID) {
      name = "Clear Dues";
      if (duesAmt > 0) name = name + " (₹ " + duesAmt + ")";
    } else {
      name = "Partial Pay";
    }
    return name;
  };

  const disableButtons = useMemo(
    () =>
      (!isEmpty(billHotelDetails.roomNo) && billDetails.payLaterSignal) ||
      (Array.isArray(billItems) && billItems.length === 0),
    [billHotelDetails.roomNo, billDetails.payLaterSignal, billItems],
  );

  const disableKitchenCopy = useMemo(
    () =>
      (billDetails.billedFrom === BillFromMachine.BILLING_MACHINE &&
        isBillPaid) ||
      (!isEmpty(billHotelDetails.roomNo) && billDetails.payLaterSignal) ||
      (Array.isArray(billItems) && billItems.length === 0),
    [
      billHotelDetails.roomNo,
      billDetails.payLaterSignal,
      billItems,
      isBillPaid,
    ],
  );

  const disablePayLater = useMemo(
    () =>
      (Array.isArray(billItems) && billItems.length === 0) ||
      !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) ||
      billDetails.payLaterSignal,
    [billDetails, billItems],
  );

  const disablePartialPay = useMemo(
    () =>
      (Array.isArray(billItems) && billItems.length === 0) ||
      (isBillPaid && billDetails.billStatus !== BillStatus.PARTIALLYPAID) ||
      billDetails.billStatus === BillStatus.NOTPAID ||
      !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE),
    [billDetails.billStatus, billItems],
  );

  const disableInitiatePayment = useMemo(
    () =>
      (!isEmpty(billHotelDetails.roomNo) && billDetails.payLaterSignal) ||
      (Array.isArray(billItems) && billItems.length === 0) ||
      isBillPaid ||
      !(
        billDetails.billStatus === BillStatus.INITIATED ||
        billDetails.billType !== InternalBillType.BookTable
      ) ||
      !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE),
    [
      billHotelDetails.roomNo,
      billDetails.payLaterSignal,
      billItems,
      isBillPaid,
      billDetails.billStatus,
      billDetails.billType,
    ],
  );

  // const disableGenerateBill = useMemo(
  //   () => !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) || isBillPaid,
  //   [isBillPaid]
  // );

  const disableGenerateBill = useMemo(
    () =>
      !(!isBillPaid && billDetails.billStatus === BillStatus.INITIATED) ||
      !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE),
    [isBillPaid, billDetails.billStatus],
  );

  const disableSettleBill = useMemo(() => {
    printDebugLog(
      "getSettleBillDisableStatus: ",
      billDetails.billStatus,
      billDetails.billType,
      billDetails.settleDown,
    );
    return (
      billDetails.billType === InternalBillType.BookTable ||
      billDetails.billStatus === BillStatus.NO_ENTRY ||
      billDetails.billStatus === BillStatus.INITIATED || //Removed NOT PAID Check
      billDetails.settleDown
    );
  }, [billDetails.billStatus, billDetails.billType, billDetails.settleDown]);

  // const diableSaveBill = useMemo(
  //   () =>
  // )
  const shouldShowKotButton = useMemo(
    () =>
      billDetails.billedFrom === BillFromMachine.BILLING_MACHINE ||
      (billDetails.billedFrom >= BillFromMachine.WEB &&
        (isEmpty(billDetails.tripStatus) ||
          billDetails.tripStatus === INITIATED ||
          billDetails.tripStatus === SEND_TO_KITCHEN)),

    [billDetails.billedFrom, billDetails.tripStatus],
  );

  const shouldShowDeleteBill = useMemo(() => {
    const isInitiatedOrPaid =
      billDetails.billStatus >= BillStatus.INITIATED || billDetails.isPaid;
    const isDeleteEnabled = getConfigValueByKey(
      restoBillConfig,
      DELETEBILLCONFIG,
    );

    return isInitiatedOrPaid && isDeleteEnabled;
  }, [billDetails.billStatus, billDetails.isPaid, restoBillConfig]);

  const shouldShowInitiatePaymentWithWhatsappBill = useMemo(() => {
    const isWhatsappBillEnabled = getConfigValueByKey(
      restoBillConfig,
      WHATSAPPBILLCONFIG,
    );

    return isWhatsappBillEnabled;
  }, [restoBillConfig]);

  const shouldShowRemoveBill = useMemo(
    () => billDetails.billStatus === BillStatus.HOMEDELIVERYINITIATED,
    [billDetails.billStatus],
  );

  const shouldShowEPayButton = useMemo(
    () =>
      getConfigValueByKey(restoBillConfig, EPAYMENTSMS) &&
      !isBillPaid &&
      billDetails.billStatus !== BillStatus.NOTPAID &&
      billDetails.billType !== InternalBillType.Home,
    [
      restoBillConfig,
      billDetails.billStatus,
      billDetails.billType,
      billDetails.isPaid,
      InternalBillType.Home,
    ],
  );

  // useEffect(() => {getSettleBillDisableStatus()}, []);
  const funAskForPrint = (payLoad) => {
    setPrintDetails({
      ...printDetails,
      shopPrint: payLoad.shopprint,
      custPrint: payLoad.custprint,
    });
    setShowCustCopyDialog(true);
  };

  const {
    initiatePayment,
    saveBill,
    kotPrint,
    generateBill,
    settleBill,
    deleteBill,
    cancelBill,
    printBill,
    payLater,
    initiateEpayLink,
    updateFoodStatus,
  } = useRestoBillActions();

  const handleCancelBill = async () => {
    if (isEmpty(cancelReason.trim())) return;
    const cancelled = await cancelBill(cancelReason);
    if (cancelled) {
      setCancelDialog(false);
      setCancelReason("");
    }
  };

  const printBillAfterPay = (e) => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    printBill(e.target.id);
    setDisableButton(false);
  };

  const handleInitiatePayLink = () => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    initiateEpayLink();
    setDisableButton(false);
  };

  const finalSettle = () => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    settleBill();
    setDisableButton(false);
  };

  const handleInitiatePayment = (
    isPartial,
    partialPayDetails,
  ) => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    initiatePayment(
      isPartial,
      false, // isWhatsappBill
      '', // whatsappNumber
      partialPayDetails,
      funAskForPrint,
    );
    setDisableButton(false);
  };

  const handleKotPrint = () => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    kotPrint();
    setDisableButton(false);
  };

  const handleSaveBill = () => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    saveBill();
    setDisableButton(false);
  };

  const deleteEntireBill = () => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    deleteBill();
    setDisableButton(false);
  };

  const handleUpdateTripStatus = () => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    updateFoodStatus();
    setDisableButton(false);
  };

  const handlePayLater = () => {
    setDisableButton(true);
    handleBillTotalMismatch(billPaymentDetails, billItems);
    payLater(funAskForPrint);
    setDisableButton(true);
  };

  // Test is instensive as billDetails.generateOtp could cause closure issue as readStaleData
  const handleGenerateBill = () => {
    const generateBillRestriction = getConfigValueByKey(
      restoBillConfig,
      GENERATEBILL,
    );
    if (generateBillRestriction && !isEmpty(billDetails.generateOtp)) {
      setShowBillOtpDialog(true);
    } else {
      setDisableButton(true);
      handleBillTotalMismatch(billPaymentDetails, billItems);
      generateBill();
      setDisableButton(false);
    }
  };

  const handleGenerateBillWithOtp = () => {
    handleBillTotalMismatch(billPaymentDetails, billItems);
    generateBill();
    setShowBillOtpDialog(false);
  };
  // Memoize button configurations to prevent unnecessary object recreation

  const shouldEnablePreviousKot = () => {
    console.log(
      "Enable prev kot: ",
      getConfigValueByKey(restoBillConfig, KOTPRINTNOWISE),
    );

    return getConfigValueByKey(restoBillConfig, KOTPRINTNOWISE);
  };

  const buttons = [
    shouldShowKotButton && {
      text: billDetails.kotNo > 0 ? "Update Kitchen Copy" : "Kitchen Copy", // what is this billDetails.kot ? is it like is kot enabled?
      disabled: disableKitchenCopy,
      onClick: () => handleKotPrint(),
    },
    {
      text: "Save Bill",
      onClick: () => handleSaveBill(),
      disabled:
        !(
          billDetails.billStatus === BillStatus.HOMEDELIVERYCASHPAY ||
          billDetails.billStatus === BillStatus.HOMEDELIVERYPAY
        ) &&
        (isBillPaid ||
          (!isEmpty(billHotelDetails.roomNo) && billDetails.payLaterSignal) ||
          (Array.isArray(billItems) && billItems.length === 0)),
    },
    shouldEnablePreviousKot() &&
      billDetails.kotNo > 0 && {
        text: "Previous KOT",
        onClick: () => setPrintKotNoDialog(true),
        disabled: false,
      },
    billDetails.billedFrom === BillFromMachine.WEB && {
      text: "Update Food Status",
      onClick: handleUpdateTripStatus,
      disabled: false,
    },
    isEmpty(billHotelDetails.roomNo) &&
      getConfigValueByKey(restoBillConfig, PARTILBILLAUDIT) && {
        text: getPartialPayButtonName(
          billDetails.billStatus,
          billPartialPaymentDetails.duesAmt,
        ),
        disabled: disablePartialPay,
        onClick: () => setShowPartialPayDialog(true),
      },
    {
      text: "Initiate Payment",
      disabled: disableInitiatePayment,
      onClick: () => handleInitiatePayment(false),
    },
    shouldShowInitiatePaymentWithWhatsappBill && {
      text: "Initiate Payment(Whatsapp Bill)",
      disabled: disableInitiatePayment,
      onClick: () => setInitiatePaymentWhatsappDialog(true),
    },
    billDetails.billStatus === BillStatus.INITIATED &&
      !isEmpty(billHotelDetails.hotelBillNo) && {
        text: "Pay Later",
        disabled: disablePayLater,
        onClick: handlePayLater,
      },
    {
      text: "Generate Bill",
      disabled: disableGenerateBill,
      onClick: handleGenerateBill,
    },
    {
      text: "Print Customer Bill",
      disabled: !billDetails.isPaid,
      onClick: printBillAfterPay,
      id: "custbill",
    },
    {
      text: "Settle Bill",
      disabled: disableSettleBill,
      onClick: finalSettle,
    },
    {
      text: "Print Shop Bill",
      disabled: !billDetails.isPaid,
      onClick: printBillAfterPay,
      id: "shopbill",
    },
    shouldShowDeleteBill && {
      text: "Delete Bill",
      onClick: deleteEntireBill,
    },
    isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) && !isEmpty(billDetails.billNo) && {
      text: "Cancel Bill",
      onClick: () => setCancelDialog(true),
      className: "cancel-bill-shine",
    },
    shouldShowRemoveBill && {
      text: "Remove Bill",
      onClick: deleteEntireBill,
    },
    shouldShowEPayButton && {
      text: "Generate Bill with E-Pay",
      onClick: handleInitiatePayLink,
    },
  ].filter(Boolean); // Remove null/false values

  return (
    <>
      <div className="billing-button-grid-container">
        {buttons.map(({ text, disabled, onClick, className }, index) => (
          <div key={index}>
            <EnterButton
              variant="contained"
              color="primary"
              className={className}
              disabled={disabledButton || disabled}
              onClick={onClick}
            >
              {text}
            </EnterButton>
          </div>
        ))}
      </div>
      <BillManagementOtpDialog
        showDialog={showBillOtpDialog}
        setShowDialog={setShowBillOtpDialog}
        handleGenerateBillWithOtp={handleGenerateBillWithOtp}
        title="Generate Bill"
      />
      <PartialPayDialog
        showDialog={showPartialPayDialog}
        setShowDialog={setShowPartialPayDialog}
        handleInitiatePayment={handleInitiatePayment}
        setShowCustCopyDialog={setShowCustCopyDialog}
        setPrintDetails={setPrintDetails}
      />
      <CustomerCopyBill
        showDialog={showCustCopyDialog}
        setShowDialog={setShowCustCopyDialog}
        printDetails={printDetails}
      />
      <PrintKotDialog
        showDialog={printKotNoDialog}
        setShowDialog={setPrintKotNoDialog}
      />
      <InitiatePaymentWhatsAppDialog
        showDialog={initiatePaymentWhatsappDialog}
        setShowDialog={setInitiatePaymentWhatsappDialog}
        title="Initiate Payment with Whatsapp Bill"
      />
      <DialogBox
        showDialog={cancelDialog}
        title="Cancel Bill"
        onClose={() => setCancelDialog(false)}
        outsideClickedDismiss={false}
        mwidth="sm"
        mFullWidth
        dialogContent={
          <Box sx={{ width: "100%", pt: 0.5 }}>
            <Box sx={{ mb: 1, fontWeight: 700, overflowWrap: "anywhere" }}>
              Why do you want to cancel this bill?
            </Box>
            <TextField
              autoFocus
              required
              fullWidth
              multiline
              minRows={3}
              label="Cancellation reason"
              placeholder="Enter reason"
              value={cancelReason}
              onChange={(event) => setCancelReason(event.target.value)}
              error={cancelDialog && isEmpty(cancelReason.trim())}
              helperText="Reason is mandatory"
            />
          </Box>
        }
        dialogActions={
          <>
            <DismissButton variant="contained" onClick={() => setCancelDialog(false)}>
              Close
            </DismissButton>
            <EnterButton variant="contained" color="error" disabled={isEmpty(cancelReason.trim())} onClick={handleCancelBill}>
              Cancel Bill
            </EnterButton>
          </>
        }
      />
    </>
  );
};

export default React.memo(BillActionButtons);
